import { EditFilled } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { Link, useParams } from "react-router-dom";

type Props = {
  page: number;
  pageSize: number;
};

const Top10ArticlesGeneralEdit = (props: Props) => {
  const { page, pageSize } = props;
  const { id } = useParams();

  return (
    <div className="flex flex-col gap-3">
      <Link
        to={`/top10-articles/edit-title/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Title
        </Button>
      </Link>
      <Link
        to={`/top10-articles/edit-description/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Description
        </Button>
      </Link>
      <Link
        to={`/top10-articles/edit-keywords/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Keywords
        </Button>
      </Link>
      <Link
        to={`/top10-articles/manage-rich-text/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Manage Rich Texts
        </Button>
      </Link>
      <Link
        to={`/top10-articles/edit-image/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Image
        </Button>
      </Link>{" "}
      <Link
        to={`/top10-articles/edit-top10-websites/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Top 10 Betting Websites
        </Button>
      </Link>{" "}
      <Link
        to={`/top10-articles/edit-sorted-items/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Sorted Items
        </Button>
      </Link>
    </div>
  );
};

export default Top10ArticlesGeneralEdit;
